var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSettingGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2801 12.49V11.5036L20.5514 10.4205C20.7857 10.2194 20.9395 9.94413 20.9855 9.6433C21.0316 9.34247 20.9669 9.03549 20.803 8.77659L19.2403 6.19786C19.1242 6.00205 18.9573 5.8394 18.7562 5.72625C18.5551 5.6131 18.3271 5.55341 18.0948 5.55318C17.9509 5.5521 17.8078 5.57388 17.6711 5.61765L16.0621 6.14629C15.7843 5.96655 15.4945 5.80503 15.1947 5.66277L14.857 4.03818C14.7964 3.74137 14.6306 3.47475 14.3885 3.28499C14.1464 3.09524 13.8435 2.99444 13.5327 3.00024H10.4339C10.1232 2.99444 9.82024 3.09524 9.57814 3.28499C9.33603 3.47475 9.17019 3.74137 9.10964 4.03818L8.77195 5.66277C8.46997 5.80499 8.178 5.96652 7.89793 6.14629L6.32205 5.59186C6.18386 5.5568 6.04076 5.54374 5.89828 5.55318C5.66605 5.55341 5.43797 5.6131 5.23692 5.72625C5.03586 5.8394 4.8689 6.00205 4.75279 6.19786L3.19014 8.77659C3.03559 9.0351 2.97816 9.33789 3.02769 9.63309C3.07721 9.9283 3.23062 10.1976 3.46162 10.3947L4.71306 11.51V12.4964L3.46162 13.5795C3.22409 13.778 3.06649 14.0521 3.0168 14.3531C2.9671 14.654 3.02851 14.9624 3.19014 15.2234L4.75279 17.8021C4.8689 17.998 5.03586 18.1606 5.23692 18.2737C5.43797 18.3869 5.66605 18.4466 5.89828 18.4468C6.0422 18.4479 6.18533 18.4261 6.32205 18.3824L7.93104 17.8537C8.20883 18.0334 8.49861 18.195 8.79844 18.3372L9.13613 19.9618C9.19668 20.2586 9.36252 20.5253 9.60462 20.715C9.84672 20.9048 10.1497 21.0056 10.4604 20.9998H13.5857C13.8964 21.0056 14.1994 20.9048 14.4415 20.715C14.6836 20.5253 14.8494 20.2586 14.91 19.9618L15.2476 18.3372C15.5496 18.195 15.8416 18.0335 16.1217 17.8537L17.724 18.3824C17.8608 18.4261 18.0039 18.4479 18.1478 18.4468C18.38 18.4466 18.6081 18.3869 18.8092 18.2737C19.0102 18.1606 19.1772 17.998 19.2933 17.8021L20.803 15.2234C20.9575 14.9649 21.015 14.6621 20.9654 14.3669C20.9159 14.0717 20.7625 13.8024 20.5315 13.6053L19.2801 12.49ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "url(#paint0_linear_3204_249475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3204_249475",
    x1: 3,
    y1: 12.0006,
    x2: 21,
    y2: 12.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettingGold);
export default __webpack_public_path__ + "static/media/User_Setting_Gold.8e1335649b9dfb31a9c9f9fd0d302685.svg";
export { ForwardRef as ReactComponent };